export default "__VITE_ASSET__LI4VJhsi__"